import { ROUTES_ROOT } from 'constants/routes/routesRoot';

/** Таймаут только для login_start — как в гайде Kaspersky (~300–500ms), fail-open. */
export const KASPERSKY_DAS_LOGIN_START_TIMEOUT_MS = 400;

/**
 * Отдельно от login_start: скачать/выполнить das.obf (~450KB).
 * Нельзя делить 400ms с login_start — иначе cold start отдаёт пустой ksid.
 */
export const KASPERSKY_DAS_SCRIPT_LOAD_TIMEOUT_MS = 3000;

export const KASPERSKY_DAS_SCRIPT_ID = 'kaspersky-das-sdk';

/** Namespace `/kredity/…`, чтобы не пересечься с чужими `/scripts` на общем домене. */
export const KASPERSKY_DAS_SCRIPT_SRC = {
  dev: `${ROUTES_ROOT}/scripts/das.obf.dev.js`,
  prod: `${ROUTES_ROOT}/scripts/das.obf.prod.js`,
} as const;
